'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDeleteSweep = function MdDeleteSweep(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.4 8.4v3.2h-20v-3.2h5l1.6-1.8h6.6l1.8 1.8h5z m-18.4 21.6v-16.6h16.6v16.6c0 1.8-1.4 3.4-3.2 3.4h-10c-1.8 0-3.4-1.6-3.4-3.4z m20-10h10v3.4h-10v-3.4z m0-6.6h11.6v3.2h-11.6v-3.2z m0 13.2h6.6v3.4h-6.6v-3.4z' })
        )
    );
};

exports.default = MdDeleteSweep;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/delete-sweep.js
// module id = 1360
// module chunks = 168707334958949